import React from 'react';
import AppHeader from '../components/AppHeader';
import { MODULES } from '../data/content';

// Imports FR
import { COURRIER_LESSONS } from '../data/courrier_lessons';
import { PDF_LESSONS } from '../data/pdf_lessons';
import { EMAIL_LESSONS } from '../data/email_lessons';
import { DOSSIER_LESSONS } from '../data/dossier_lessons';
import { SECURITE_LESSONS } from '../data/securite_lessons';
import { IMPOTS_LESSONS } from '../data/impots_lessons';
import { CARTEVITALE_LESSONS } from '../data/cartevitale_lessons';
import { RSACAF_LESSONS } from '../data/rsacaf_lessons';
import { LOGEMENT_LESSONS } from '../data/logement_lessons';
import { DOSSIERMEDICAL_LESSONS } from '../data/dossiermedical_lessons';
import { FORMATION_LESSONS } from '../data/formation_lessons';
import { PERMIS_LESSONS } from '../data/permis_lessons';
import { BANQUE_LESSONS } from '../data/banque_lessons';
import { SMARTPHONE_LESSONS } from '../data/smartphone_lessons';

// Imports AR
import { COURRIER_LESSONS_AR } from '../data/courrier_lessons_ar';
import { PDF_LESSONS_AR } from '../data/pdf_lessons_ar';
import { EMAIL_LESSONS_AR } from '../data/email_lessons_ar';
import { DOSSIER_LESSONS_AR } from '../data/dossier_lessons_ar';
import { SECURITE_LESSONS_AR } from '../data/securite_lessons_ar';
import { IMPOTS_LESSONS_AR } from '../data/impots_lessons_ar';
import { CARTEVITALE_LESSONS_AR } from '../data/cartevitale_lessons_ar';
import { RSACAF_LESSONS_AR } from '../data/rsacaf_lessons_ar';
import { LOGEMENT_LESSONS_AR } from '../data/logement_lessons_ar';
import { DOSSIERMEDICAL_LESSONS_AR } from '../data/dossiermedical_lessons_ar';
import { FORMATION_LESSONS_AR } from '../data/formation_lessons_ar';
import { PERMIS_LESSONS_AR } from '../data/permis_lessons_ar';
import { BANQUE_LESSONS_AR } from '../data/banque_lessons_ar';
import { SMARTPHONE_LESSONS_AR } from '../data/smartphone_lessons_ar';

// Imports PT
import { COURRIER_LESSONS_PT } from '../data/courrier_lessons_pt';
import { PDF_LESSONS_PT } from '../data/pdf_lessons_pt';
import { EMAIL_LESSONS_PT } from '../data/email_lessons_pt';
import { DOSSIER_LESSONS_PT } from '../data/dossier_lessons_pt';
import { SECURITE_LESSONS_PT } from '../data/securite_lessons_pt';
import { IMPOTS_LESSONS_PT } from '../data/impots_lessons_pt';
import { CARTEVITALE_LESSONS_PT } from '../data/cartevitale_lessons_pt';
import { RSACAF_LESSONS_PT } from '../data/rsacaf_lessons_pt';
import { LOGEMENT_LESSONS_PT } from '../data/logement_lessons_pt';
import { DOSSIERMEDICAL_LESSONS_PT } from '../data/dossiermedical_lessons_pt';
import { FORMATION_LESSONS_PT } from '../data/formation_lessons_pt';
import { PERMIS_LESSONS_PT } from '../data/permis_lessons_pt';
import { BANQUE_LESSONS_PT } from '../data/banque_lessons_pt';
import { SMARTPHONE_LESSONS_PT } from '../data/smartphone_lessons_pt';

// Imports EN
import { COURRIER_LESSONS_EN } from '../data/courrier_lessons_en';
import { PDF_LESSONS_EN } from '../data/pdf_lessons_en';
import { EMAIL_LESSONS_EN } from '../data/email_lessons_en';
import { DOSSIER_LESSONS_EN } from '../data/dossier_lessons_en';
import { SECURITE_LESSONS_EN } from '../data/securite_lessons_en';
import { IMPOTS_LESSONS_EN } from '../data/impots_lessons_en';
import { CARTEVITALE_LESSONS_EN } from '../data/cartevitale_lessons_en';
import { RSACAF_LESSONS_EN } from '../data/rsacaf_lessons_en';
import { LOGEMENT_LESSONS_EN } from '../data/logement_lessons_en';
import { DOSSIERMEDICAL_LESSONS_EN } from '../data/dossiermedical_lessons_en';
import { FORMATION_LESSONS_EN } from '../data/formation_lessons_en';
import { PERMIS_LESSONS_EN } from '../data/permis_lessons_en';
import { BANQUE_LESSONS_EN } from '../data/banque_lessons_en';
import { SMARTPHONE_LESSONS_EN } from '../data/smartphone_lessons_en';

// Imports IT
import { COURRIER_LESSONS_IT } from '../data/courrier_lessons_it';
import { PDF_LESSONS_IT } from '../data/pdf_lessons_it';
import { EMAIL_LESSONS_IT } from '../data/email_lessons_it';
import { DOSSIER_LESSONS_IT } from '../data/dossier_lessons_it';
import { SECURITE_LESSONS_IT } from '../data/securite_lessons_it';
import { IMPOTS_LESSONS_IT } from '../data/impots_lessons_it';
import { CARTEVITALE_LESSONS_IT } from '../data/cartevitale_lessons_it';
import { RSACAF_LESSONS_IT } from '../data/rsacaf_lessons_it';
import { LOGEMENT_LESSONS_IT } from '../data/logement_lessons_it';
import { DOSSIERMEDICAL_LESSONS_IT } from '../data/dossiermedical_lessons_it';
import { FORMATION_LESSONS_IT } from '../data/formation_lessons_it';
import { PERMIS_LESSONS_IT } from '../data/permis_lessons_it';
import { BANQUE_LESSONS_IT } from '../data/banque_lessons_it';
import { SMARTPHONE_LESSONS_IT } from '../data/smartphone_lessons_it';

// Imports ES
import { COURRIER_LESSONS_ES } from '../data/courrier_lessons_es';
import { PDF_LESSONS_ES } from '../data/pdf_lessons_es';
import { EMAIL_LESSONS_ES } from '../data/email_lessons_es';
import { DOSSIER_LESSONS_ES } from '../data/dossier_lessons_es';
import { SECURITE_LESSONS_ES } from '../data/securite_lessons_es';
import { IMPOTS_LESSONS_ES } from '../data/impots_lessons_es';
import { CARTEVITALE_LESSONS_ES } from '../data/cartevitale_lessons_es';
import { RSACAF_LESSONS_ES } from '../data/rsacaf_lessons_es';
import { LOGEMENT_LESSONS_ES } from '../data/logement_lessons_es';
import { DOSSIERMEDICAL_LESSONS_ES } from '../data/dossiermedical_lessons_es';
import { FORMATION_LESSONS_ES } from '../data/formation_lessons_es';
import { PERMIS_LESSONS_ES } from '../data/permis_lessons_es';
import { BANQUE_LESSONS_ES } from '../data/banque_lessons_es';
import { SMARTPHONE_LESSONS_ES } from '../data/smartphone_lessons_es';

// Imports ZH
import { COURRIER_LESSONS_ZH } from '../data/courrier_lessons_zh';
import { PDF_LESSONS_ZH } from '../data/pdf_lessons_zh';
import { EMAIL_LESSONS_ZH } from '../data/email_lessons_zh';
import { DOSSIER_LESSONS_ZH } from '../data/dossier_lessons_zh';
import { SECURITE_LESSONS_ZH } from '../data/securite_lessons_zh';
import { IMPOTS_LESSONS_ZH } from '../data/impots_lessons_zh';
import { CARTEVITALE_LESSONS_ZH } from '../data/cartevitale_lessons_zh';
import { RSACAF_LESSONS_ZH } from '../data/rsacaf_lessons_zh';
import { LOGEMENT_LESSONS_ZH } from '../data/logement_lessons_zh';
import { DOSSIERMEDICAL_LESSONS_ZH } from '../data/dossiermedical_lessons_zh';
import { FORMATION_LESSONS_ZH } from '../data/formation_lessons_zh';
import { PERMIS_LESSONS_ZH } from '../data/permis_lessons_zh';
import { BANQUE_LESSONS_ZH } from '../data/banque_lessons_zh';
import { SMARTPHONE_LESSONS_ZH } from '../data/smartphone_lessons_zh';

const LESSONS_MAP = { courrier: COURRIER_LESSONS, pdf: PDF_LESSONS, email: EMAIL_LESSONS, dossier: DOSSIER_LESSONS, securite: SECURITE_LESSONS, impots: IMPOTS_LESSONS, cartevitale: CARTEVITALE_LESSONS, rsacaf: RSACAF_LESSONS, logement: LOGEMENT_LESSONS, dossiermedical: DOSSIERMEDICAL_LESSONS, formation: FORMATION_LESSONS, permis: PERMIS_LESSONS, banque: BANQUE_LESSONS, smartphone: SMARTPHONE_LESSONS };
const LESSONS_MAP_AR = { courrier: COURRIER_LESSONS_AR, pdf: PDF_LESSONS_AR, email: EMAIL_LESSONS_AR, dossier: DOSSIER_LESSONS_AR, securite: SECURITE_LESSONS_AR, impots: IMPOTS_LESSONS_AR, cartevitale: CARTEVITALE_LESSONS_AR, rsacaf: RSACAF_LESSONS_AR, logement: LOGEMENT_LESSONS_AR, dossiermedical: DOSSIERMEDICAL_LESSONS_AR, formation: FORMATION_LESSONS_AR, permis: PERMIS_LESSONS_AR, banque: BANQUE_LESSONS_AR, smartphone: SMARTPHONE_LESSONS_AR };
const LESSONS_MAP_PT = { courrier: COURRIER_LESSONS_PT, pdf: PDF_LESSONS_PT, email: EMAIL_LESSONS_PT, dossier: DOSSIER_LESSONS_PT, securite: SECURITE_LESSONS_PT, impots: IMPOTS_LESSONS_PT, cartevitale: CARTEVITALE_LESSONS_PT, rsacaf: RSACAF_LESSONS_PT, logement: LOGEMENT_LESSONS_PT, dossiermedical: DOSSIERMEDICAL_LESSONS_PT, formation: FORMATION_LESSONS_PT, permis: PERMIS_LESSONS_PT, banque: BANQUE_LESSONS_PT, smartphone: SMARTPHONE_LESSONS_PT };
const LESSONS_MAP_EN = { courrier: COURRIER_LESSONS_EN, pdf: PDF_LESSONS_EN, email: EMAIL_LESSONS_EN, dossier: DOSSIER_LESSONS_EN, securite: SECURITE_LESSONS_EN, impots: IMPOTS_LESSONS_EN, cartevitale: CARTEVITALE_LESSONS_EN, rsacaf: RSACAF_LESSONS_EN, logement: LOGEMENT_LESSONS_EN, dossiermedical: DOSSIERMEDICAL_LESSONS_EN, formation: FORMATION_LESSONS_EN, permis: PERMIS_LESSONS_EN, banque: BANQUE_LESSONS_EN, smartphone: SMARTPHONE_LESSONS_EN };
const LESSONS_MAP_IT = { courrier: COURRIER_LESSONS_IT, pdf: PDF_LESSONS_IT, email: EMAIL_LESSONS_IT, dossier: DOSSIER_LESSONS_IT, securite: SECURITE_LESSONS_IT, impots: IMPOTS_LESSONS_IT, cartevitale: CARTEVITALE_LESSONS_IT, rsacaf: RSACAF_LESSONS_IT, logement: LOGEMENT_LESSONS_IT, dossiermedical: DOSSIERMEDICAL_LESSONS_IT, formation: FORMATION_LESSONS_IT, permis: PERMIS_LESSONS_IT, banque: BANQUE_LESSONS_IT, smartphone: SMARTPHONE_LESSONS_IT };
const LESSONS_MAP_ES = { courrier: COURRIER_LESSONS_ES, pdf: PDF_LESSONS_ES, email: EMAIL_LESSONS_ES, dossier: DOSSIER_LESSONS_ES, securite: SECURITE_LESSONS_ES, impots: IMPOTS_LESSONS_ES, cartevitale: CARTEVITALE_LESSONS_ES, rsacaf: RSACAF_LESSONS_ES, logement: LOGEMENT_LESSONS_ES, dossiermedical: DOSSIERMEDICAL_LESSONS_ES, formation: FORMATION_LESSONS_ES, permis: PERMIS_LESSONS_ES, banque: BANQUE_LESSONS_ES, smartphone: SMARTPHONE_LESSONS_ES };
const LESSONS_MAP_ZH = { courrier: COURRIER_LESSONS_ZH, pdf: PDF_LESSONS_ZH, email: EMAIL_LESSONS_ZH, dossier: DOSSIER_LESSONS_ZH, securite: SECURITE_LESSONS_ZH, impots: IMPOTS_LESSONS_ZH, cartevitale: CARTEVITALE_LESSONS_ZH, rsacaf: RSACAF_LESSONS_ZH, logement: LOGEMENT_LESSONS_ZH, dossiermedical: DOSSIERMEDICAL_LESSONS_ZH, formation: FORMATION_LESSONS_ZH, permis: PERMIS_LESSONS_ZH, banque: BANQUE_LESSONS_ZH, smartphone: SMARTPHONE_LESSONS_ZH };

export default function Module({ moduleId, onNavigate, onStartLesson, completedLessons = [], large, toggleText, scale = 1, t, isRTL, lang, switchLang, onDiagnostic }) {
  const mod = MODULES.find(m => m.id === moduleId);
  if (!mod) return <div style={{ padding: 32, textAlign: 'center', color: '#666' }}>Module introuvable</div>;

  const lessons =
    (lang === 'ar' && LESSONS_MAP_AR[moduleId]) ? LESSONS_MAP_AR[moduleId] :
    (lang === 'pt' && LESSONS_MAP_PT[moduleId]) ? LESSONS_MAP_PT[moduleId] :
    (lang === 'en' && LESSONS_MAP_EN[moduleId]) ? LESSONS_MAP_EN[moduleId] :
    (lang === 'it' && LESSONS_MAP_IT[moduleId]) ? LESSONS_MAP_IT[moduleId] :
    (lang === 'es' && LESSONS_MAP_ES[moduleId]) ? LESSONS_MAP_ES[moduleId] :
    (lang === 'zh' && LESSONS_MAP_ZH[moduleId]) ? LESSONS_MAP_ZH[moduleId] :
    (LESSONS_MAP[moduleId] || []);

  const completedCount = completedLessons.filter(id => lessons.some(l => l.id === id)).length;

  return (
    <div style={{ minHeight: '100vh', background: '#F5F5FE', direction: isRTL ? 'rtl' : 'ltr' }}>
      <AppHeader onNavigate={onNavigate} onBack={() => onNavigate('home')}
        backLabel={t?.nav?.back || 'Retour'}
        large={large} toggleText={toggleText} t={t} isRTL={isRTL}
        lang={lang} switchLang={switchLang} onDiagnostic={onDiagnostic} />

      <div style={{ maxWidth: 680, margin: '0 auto', padding: '1.5rem 1rem 6rem' }}>
        {/* En-tête module */}
        <div style={{
          background: '#003189', borderRadius: 16, padding: '1.5rem',
          marginBottom: 16, boxShadow: '0 4px 16px rgba(0,49,137,0.15)',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 12 }}>
            <div style={{
              width: 56, height: 56, borderRadius: 14,
              background: `${mod.color}25`, border: `2px solid ${mod.color}50`,
              display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 28,
            }}>{mod.icon}</div>
            <div>
              <h1 style={{ fontFamily: 'Fraunces, serif', fontSize: 22, fontWeight: 700, color: '#fff', margin: '0 0 4px' }}>
                {t?.moduleNames?.[moduleId] || mod.title}
              </h1>
              <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.7)' }}>
                {completedCount} / {lessons.length} {t?.modules?.lessons || 'leçons'}
              </div>
            </div>
          </div>
          {/* Barre de progression */}
          <div style={{ background: 'rgba(255,255,255,0.2)', borderRadius: 6, height: 8, overflow: 'hidden' }}>
            <div style={{
              background: '#fff', height: '100%', borderRadius: 6,
              width: `${lessons.length > 0 ? (completedCount / lessons.length) * 100 : 0}%`,
              transition: 'width 0.4s ease',
            }} />
          </div>
        </div>

        {/* Liste des leçons */}
        {lessons.map((lesson, i) => {
          const done = completedLessons.includes(lesson.id);
          return (
            <div key={lesson.id}
              onClick={() => onStartLesson(lesson, moduleId, lessons.length, t?.moduleNames?.[moduleId] || mod.title)}
              style={{
                background: '#fff', borderRadius: 14,
                padding: '1.1rem 1.2rem', marginBottom: 8, cursor: 'pointer',
                border: done ? `1.5px solid ${mod.color}60` : '1.5px solid #E8E8E8',
                display: 'flex', alignItems: 'center', gap: 14,
                boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
                transition: 'all 0.15s ease',
                animation: `fadeUp 0.3s ${i * 0.07}s ease both`,
                opacity: 0, animationFillMode: 'forwards',
              }}
              onMouseEnter={e => {
                e.currentTarget.style.borderColor = mod.color;
                e.currentTarget.style.transform = 'translateX(3px)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.borderColor = done ? `${mod.color}60` : '#E8E8E8';
                e.currentTarget.style.transform = 'translateX(0)';
              }}>
              <div style={{
                width: 36, height: 36, borderRadius: 10, flexShrink: 0,
                background: done ? mod.color : '#F0F0F0',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: done ? 18 : 14, fontWeight: 700,
                color: done ? '#fff' : '#888',
              }}>
                {done ? '✓' : lesson.numero}
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 700, fontSize: 15 * scale, color: '#1A1A1A', marginBottom: 2 }}>
                  {lesson.titre}
                </div>
                <div style={{ fontSize: 12 * scale, color: '#666' }}>{lesson.sousTitre}</div>
              </div>
              <div style={{ color: '#CCC', fontSize: 20 }}>{isRTL ? '‹' : '›'}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
